import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths } from 'src/constants';
import { useIntlMessages } from 'src/hooks';

import { Container } from './components';

const ClimbStepTwoCollections = ({
  climbStepTwoCollections,
  climbStepTwoCurrency,
  getCollections,
  hasLoaded,
  student,
}) => {
  const messages = useIntlMessages();

  return (
    <Container
      className="climb-collections-container--step-two"
      currency={climbStepTwoCurrency}
      getCollections={getCollections}
      hasLoaded={hasLoaded}
      items={climbStepTwoCollections}
      levelsPath={paths.CLIMB_STEP_TWO_LEVELS}
      student={student}
      title={messages.subactivity.climbStepTwo}
    />
  );
};

ClimbStepTwoCollections.propTypes = {
  climbStepTwoCollections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  climbStepTwoCurrency: PropTypes.shape({}).isRequired,
  getCollections: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  student: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.climbStepTwoCollections.getHasLoaded(state),
  climbStepTwoCollections: selectors.climbStepTwoCollections.getCollectionsData(
    state
  ),
  climbStepTwoCurrency: selectors.climbStepTwoCollections.getCurrencyData(
    state
  ),
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {
  ...actions.climbStepTwo,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(ClimbStepTwoCollections);
